var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPictureLandscape = function SvgPictureLandscape(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6zm-1.333 12a.667.667 0 0 1-.667.667H6A.667.667 0 0 1 5.333 18V6A.667.667 0 0 1 6 5.333h12a.667.667 0 0 1 .667.667v12zm-12-8.667A1.333 1.333 0 0 0 8 10.667h2a2 2 0 1 0-1.841-2.77A.168.168 0 0 1 8 8a1.333 1.333 0 0 0-1.333 1.333zm8.539 3.398c.192.124.348.298.45.504l1.975 3.949a.333.333 0 0 1-.298.483H7a.334.334 0 0 1-.31-.46c.123-.304 1.247-3 2.824-3a3.4 3.4 0 0 1 2.324 1.244.167.167 0 0 0 .214.027.166.166 0 0 0 .053-.056l1.318-2.26a1.267 1.267 0 0 1 1.783-.431z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPictureLandscape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "picture-landscape.5ea1de6d9a4abf29c228b51527622740.svg";